import React, { Component, useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Products } from "@/components/Products";
import { Formulation } from "@/components/Formulation";
import { Cinema } from "@/components/Cinema";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

class ErrorBoundary extends Component {
  state = { hasError: false };
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-ivory text-sm text-smoke">
          Qualcosa è andato storto. Ricarica la pagina.
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <ErrorBoundary>
      <div className="relative min-h-screen overflow-x-clip bg-ivory font-body text-ink">
        {/* Fixed, full-height gold ribbon on the right edge. z-10: below the marquee (z-30) and the nav (z-50). */}
        <div
          aria-hidden="true"
          data-testid="gold-side-ribbon"
          className="gold-side-ribbon pointer-events-none hidden bg-gold-grad lg:block"
        />
        <Nav />
        <main>
          <Hero />
          <Marquee />
          <Products />
          <Formulation />
          <Cinema />
          <Contact />
        </main>
        <Footer />
        <Toaster position="bottom-right" richColors />
      </div>
    </ErrorBoundary>
  );
}

export default App;
